module.exports = __webpack_public_path__ + "static/media/calculator.db84f902.png";